import "../css/TicketInfo.css";

const TicketViewers = ({viewers}) => {
    return <>
        <h3>Active Viewers</h3>

        <div style={{gap: "5px"}} className="ticket-info-row ticket-viewer-container">
            {viewers.map((viewer) => {
                return <img title={viewer.username} src={viewer.imageurl}/>
            })}
        </div>
    </>
}

export default TicketViewers;